import { z } from 'zod';
import { emailValidation, nameValidation } from '../../validation';

export const ReferrerSchema = z.object({
  firstname: nameValidation('Referrer first name is required'),
  lastname: nameValidation('Referrer surname is required'),
  email: emailValidation('Referrer email is required'),
});

export type Referrer = z.infer<typeof ReferrerSchema>;
